<template>
	<Accordion
		:open="open"
		data-qa-form-accordion
		:data-qa-accordion-field="title"
		:bottom-border="true"
	>
		<template #header>
			<Slab
				:effects="false"
				size="medium"
				type="transparent"
				:no-padding="true"
				:overflow="'visible'"
				class="cursor-pointer"
				@click="open = !open"
			>
				<Container padding="16px 0px">
					<Typography data-qa-accordion-title type="p1">{{ title }}</Typography>
				</Container>

				<template #secondary-actions>
					<Icon
						name="i-chevron-down"
						class="margin-rt-12"
						type="filled"
						size="small"
						data-qa-toggle-accordion
						:rotate="open ? 180 : 0"
						@click.stop="open = !open"
					/>
				</template>
			</Slab>
		</template>
		<slot />
	</Accordion>
</template>
<script lang="ts">
import Accordion from "./../Wrappers/Accordion/Accordion.vue";
import Slab from "./../Slab/Slab.vue";
import Icon from "./../Icon/Icon.vue";
import Container from "./../Container/Container.vue";
import Typography from "./../Typography/Typography.vue";
import { defineComponent } from "vue";

export default defineComponent({
	name: "AccordionField",

	components: {
		Accordion,
		Slab,
		Icon,
		Container,
		Typography
	},

	props: {
		title: {
			type: String,
			default: () => null
		}
	},

	data: () => ({
		open: false
	})
});
</script>
